import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Events can be ingested directly using our API and the `}<a parentName="p" {...{
        "href": "/docs/api/post-only-endpoints#capture"
      }}><inlineCode parentName="a">{`/capture`}</inlineCode></a>{` endpoint, which is the same endpoint that all of our libraries use behind the scenes.`}</p>
    <p>{`Generally, this isn't something you'll need to use when integrating PostHog, but if you're working with a language or framework that PostHog doesn't support yet, this will allow you to still send events.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` For this API, you should use your 'Project API Key' from the 'Project' page in PostHog. This is the same key used in your frontend snippet.`}</p>
    </blockquote>
    <h1 {...{
      "id": "sending-events"
    }}>{`Sending events`}</h1>
    <p>{`Events can be sent either one at a time, or together in a batch. There is no limit on the number of events you can send in a batch, but the entire request body must be less than `}<inlineCode parentName="p">{`20MB`}</inlineCode>{` by default.`}</p>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-shell",
          "metastring": "label=Single",
          "label": "Single"
        }}>{`POST https://[your-instance].com/capture/
Content-Type: application/json
Body:
{
    "api_key": "<ph_project_api_key>",
    "event": "[event name]",
    "properties": {
        "distinct_id": "[your users' distinct id]",
        "key1": "value1",
        "key2": "value2"
    },
    "timestamp": "[optional timestamp in ISO 8601 format]"
}
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-shell",
          "metastring": "label=Batch",
          "label": "Batch"
        }}>{`POST https://[your-instance].com/batch/
Content-Type: application/json
Body:
{
    "api_key": "<ph_project_api_key>",
    "batch": [
        {
            "event": "[event name]",
            "properties": {
                "distinct_id": "[your users' distinct id]",
                "key1": "value1",
                "key2": "value2"
            },
            "timestamp": "[optional timestamp in ISO 8601 format]"
        },
        ...
    ]
}
`}</code></pre>
    </MultiLanguage>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Timestamp is optional. If not set, it'll automatically be set to the current time.`}</p>
    </blockquote>
    <p>{`For more information, read our `}<a parentName="p" {...{
        "href": "/docs/api/post-only-endpoints"
      }}>{`API docs`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      